export default "__VITE_ASSET__Dpzxqxjq__"